import { useState, useEffect, useCallback } from 'react';
import { getRecommendedReferees } from '@/api/TournamentManagement/refereeApi';
import type { RefereeRecommendationView } from '@/models/tournament';

export function useRefereeRecommendations(matchId: number | null) {
  const [data, setData] = useState<RefereeRecommendationView[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (matchId === null) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await getRecommendedReferees(matchId);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [matchId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
